<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>活动管理</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>设置报名</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page">
      <!--<h3>{{ meeting.title }}</h3>-->
      <Row :gutter="16">
        <Col span="17">
        <Card id="settingCard">
          <p slot="title">
            <router-link :to="{name: 'meeting-list'}">
              <Icon type="ios-arrow-back"></Icon>
            </router-link>
            报名设置：{{ meeting.title }}
          </p>
          <Button type="primary" @click="save" size="small" slot="extra">保存设置</Button>
          <Row :gutter="8">
              <Col span="10">
              <Card >
                <p slot="title">
                  第一步：设置报名信息
                </p>
                <Form ref="formValidate" class="meeting-form" :model="signSetting" >
                  <!--<FormItem label="报名开始时间">-->
                  <!--<DatePicker v-model="signSetting.signStartDate" size="large" type="datetime" show-week-numbers placeholder="选择日期和时间"-->
                  <!--format="yyyy-MM-dd HH:mm" style="width: 100%" ></DatePicker>-->
                  <!--</FormItem>-->
                  <FormItem label="报名截止时间：" prop="signEndDate">
                    <DatePicker :value="formatDate(signSetting.signEndDate, 'YYYY-MM-DD HH:mm')" @on-change="handleSignEndDateChange" type="datetime" size="large" show-week-numbers placeholder="不设置表示时间待定"
                                format="yyyy-MM-dd HH:mm" style="width: 100%"></DatePicker>
                  </FormItem>
                  <FormItem label="活动规模:">
                    <InputNumber v-model="signSetting.signLimitPersonNumber" placeholder="" ></InputNumber> 人
                  </FormItem>
                  <Alert>提示：活动规模非必填，仅用于展示，不会限制用户的报名数量。</Alert>

                  <!--<FormItem>-->
                  <!--<Checkbox v-model="signSetting.signNeedApproval">报名需要审核</Checkbox>-->
                  <!--</FormItem>-->
                </Form>
              </Card>
              </Col>
              <Col span="14">
              <Card class="meeting-components">
                <p slot="title">
                  <Icon type="ios-setting-outline"></Icon>
                  第二步：设置报名项
                </p>
                <Card style="margin-bottom: 20px" v-for="(step, stepIndex) in signSetting.signMeetingSteps" :key="stepIndex">
                  <p slot="title">
                    第{{ stepIndex+1 }}部分：{{ step.title }}
                  </p>
                  <div style="min-height: 60px;">
                    <draggable v-model="step.componentList" class="iview-admin-draggable-list meeting-component" element="ul" :options="stepOption">
                      <li v-for="(item, index) in step.componentList" :key="index" class="notwrap todolist-item" :class="{mustComponent: item.signFormComponent.mustComponent}">
                        <Row>
                          <Col span="12">{{ item.signFormComponent.label }}</Col>
                          <Col span="6"> <Checkbox :disabled="item.signFormComponent.mustComponent" v-model="item.isRequired">必填</Checkbox></Col>
                          <Col span="6" style="text-align: right"><Button v-if="!item.signFormComponent.mustComponent" type="default" size="small" @click="removeComponent(stepIndex, index)">删除</Button></Col>
                        </Row>
                      </li>
                    </draggable>
                  </div>
                </Card>
                <Card style="margin-bottom: 20px" v-if="meeting.free === 0" >
                  <p slot="title">
                    <Checkbox size="large" v-model="signSetting.uploadBankSlip">第3部分：上传银行转账回执</Checkbox>
                  </p>
                </Card>
                <Card v-if="meeting.free === 0" >
                  <p slot="title">
                    <Checkbox size="large" v-model="signSetting.showInvoice">第4部分：填写发票信息</Checkbox>
                  </p>
                </Card>
              </Card>
              </Col>
            </Row>
        </Card>
        </Col>
        <Col span="7">
        <Affix :offset-top="64">
        <Card class="system-components">
          <p slot="title">
            <Icon type="ios-list-outline"></Icon>
            组件库（拖拽到左侧添加）
          </p>
          <Collapse v-model="colPanelName" accordion style="max-height: 490px; overflow: scroll">
            <Panel v-for="group in wrappedComponentGroups" :key="group.id" :name="'p' + group.id">
              {{ group.groupName }}
              <div slot="content">
                <div v-if="group.id === 3">
                  <Button type="success" @click="showCustomComponentDialog = true" size="small" style="margin-bottom: 5px">创建新的组件</Button>
                </div>
                <draggable v-model="group.formComponentList" :clone="handleClone" element="ul" class="iview-admin-draggable-list" :options="componentsOption">
                  <li v-for="(item, index) in group.formComponentList" :key="index" class="notwrap todolist-item" v-if="!item.signFormComponent.mustComponent">
                    {{ item.signFormComponent.label }}
                    <Poptip trigger="hover" placement="bottom-end" transfer>
                      <Icon type="ios-information-circle" style="font-size: 18px; color: #d9d9d9"/>
                      <div slot="title">{{ getTipsTitle(item.signFormComponent) }}
                        <a v-if="group.id === 3" href="javascript:void(0)" @click="showEditCustomComponentModal(item.signFormComponent)" style="float: right"><Icon type="md-create" style="font-size: 18px"/></a>
                      </div>
                      <div slot="content">
                        <p></p>
                        <ul  v-if="item.signFormComponent.type === 'select' || item.signFormComponent.type === 'radio' || item.signFormComponent.type === 'checkbox'">
                          <li v-for="(option, index) in item.signFormComponent.optionsArray" :key="index">
                            {{ option.name }}
                          </li>
                        </ul>
                      </div>
                    </Poptip>
                    <Poptip transfer
                        confirm
                        title="确认删除吗? 删除组件不会影响已有的报名"
                        @on-ok="removeCustomComponent(item.signFormComponent.id)">
                    <Icon v-if="group.id === 3" type="ios-trash-outline" style="font-size: 18px"/>
                    </Poptip>

                  </li>
                </draggable>
              </div>
            </Panel>
          </Collapse>
        </Card>
        </Affix>
        </Col>
      </Row>
      <Modal
          v-model="showCustomComponentDialog"
          title="编辑自定义组件"
          :loading="modalLoading"
          @on-ok="saveCustomComponent()"
          >
        <Alert type="warning" v-if="newCustomComponent.id">如果要修改组件的类型和选项，请确保没有其他活动使用此组件。建议创建新的组件来实现。</Alert>
        <Form ref="customComponentFormValidate" :model="newCustomComponent" :rules="ruleValidate" label-position="top">
          <FormItem label="组件名称" prop="componentName">
            <Input v-model.trim="newCustomComponent.label" size="large" placeholder=""></Input>
          </FormItem>
          <FormItem label="组件类型" >
            <RadioGroup v-model="newCustomComponent.type">
              <Radio label="input">单行文本框</Radio>
              <Radio label="textarea">多行文本框</Radio>
              <Radio label="select">下拉选择框</Radio>
              <Radio label="radio">单选按钮</Radio>
              <Radio label="checkbox">多选框</Radio>
              <Radio label="uploadConfigImg">图片附件</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="newCustomComponent.type === 'input' || newCustomComponent.type === 'textarea'" label="文本框最多允许输入多少个字符">
            <Input v-model="newCustomComponent.valueLength" size="large" placeholder=""></Input>
          </FormItem>
          <!-- <FormItem v-if="newCustomComponent.type === 'uploadConfigImg'" label="允许的文件类型">
            <Input v-model="newCustomComponent.uploadFileAllowTypes" size="large" placeholder="image/*" value="image/*"></Input>
          </FormItem> -->
          <FormItem v-if="newCustomComponent.type === 'uploadConfigImg'" label="文件大小限制(MB)">
            <InputNumber v-model="newCustomComponent.uploadFileMaxMbSize" placeholder="10"></InputNumber>
          </FormItem>
          <FormItem v-if="newCustomComponent.type === 'uploadConfigImg'" label="上传图片数量">
            <Checkbox v-model="newCustomComponent.uploadMultiple">允许上传多张</Checkbox>
          </FormItem>
          <FormItem v-if="newCustomComponent.type === 'uploadConfigImg'" label="默认提示文字">
            <Input v-model="newCustomComponent.tips" size="large" placeholder="请上传图片附件" value="请上传图片附件"></Input>
          </FormItem>
          <FormItem v-if="newCustomComponent.type === 'uploadConfigImg'" label="错误提示文字">
            <Input v-model="newCustomComponent.errorTips" size="large" placeholder="请上传图片附件" value="请上传图片附件"></Input>
          </FormItem>
          <FormItem v-if="newCustomComponent.type === 'select' || newCustomComponent.type === 'radio' || newCustomComponent.type === 'checkbox'" label="选择项">
            <div v-for="(option, index) in newCustomComponent.optionsArray" :key="index" style="margin-bottom: 5px">
              <Input v-model="option.name" style="width: 70%"></Input>
              <Button size="small" type="primary" style="margin: 0 10px" @click="addOption(index)">增加</Button>
              <Button size="small" type="primary" @click="removeOption(index)">删除</Button>
            </div>
          </FormItem>
        </Form>
      </Modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'
import draggable from 'vuedraggable'

export default {
  name: 'MeetingSignSetting',
  props: {
    meetingId: {
      type: [String, Number],
      required: true
    },
    id: {
      type: [String, Number],
      required: false
    }
  },
  components: {
    draggable
  },
  data () {
    return {
      meeting: {},
      signSetting: {
        signLimitPersonNumber: null
      },
      componentGroups: [],
      showCustomComponentDialog: false,
      modalLoading: true,
      stepOption: {
        group: {
          name: 'list'
        },
        animation: 120,
        filter: '.mustComponent',
        ghostClass: 'placeholder-style',
        fallbackClass: 'iview-admin-cloned-item'
      },
      componentsOption: {
        group: {
          name: 'list',
          pull: 'clone',
          put: false
        },
        sort: false,
        animation: 120,
        ghostClass: 'placeholder-style',
        fallbackClass: 'iview-admin-cloned-item'
      },
      saving: false,
      saved: false,
      colPanelName: '',
      ruleValidate: {
        label: [
          {required: true, message: '请输入组件名称'}
        ]
      },
      newCustomComponent: {
        label: null,
        type: 'input',
        valueLength: null,
        options: '',
        optionsArray: [{name: ''}],
        uploadFileAllowTypes: 'image/*',
        uploadFileMaxMbSize: 10,
        uploadMultiple: false,
        tips: '请上传图片附件',
        errorTips: '请上传图片附件'
      },
      componentTypeText: {
        input: '单行文本',
        textarea: '多行文本',
        select: '下拉选择',
        radio: '单选',
        checkbox: '多选',
        uploadImg: '上传图片',
        uploadConfigImg: '图片附件'
      }
    }
  },
  computed: {
    ...mapState([
      'token'
    ]),
    wrappedComponentGroups () {
      let customGroup = this.componentGroups.find(item => {
        return item.id === 3
      })

      if (customGroup && customGroup.formComponentList) {
        customGroup.formComponentList.sort(function (c1, c2) {
          return c2.id - c1.id
        })
      }

      let wrap = JSON.parse(JSON.stringify(this.componentGroups))
      wrap.forEach(group => {
        group.formComponentList = group.formComponentList.map(item => {
          return {signFormComponent: item, isRequired: false}
        })
      })
      return wrap
    }
  },
  methods: {
    getTipsTitle (component) {
      return this.componentTypeText[component.type]
    },
    showEditCustomComponentModal (component) {
      if (component.type === 'uploadConfigImg') {
        component.uploadFileMaxMbSize = parseFloat((component.uploadFileMaxKbSize / 1024).toFixed(2))
      }
      this.newCustomComponent = component
      this.showCustomComponentDialog = true
    },
    handleSignEndDateChange (date) {
      if (date) {
        this.signSetting.signEndDate = new Date(date)
      } else {
        this.signSetting.signEndDate = null
      }
    },
    formatDate (timestamp, pattern) {
      if (timestamp) {
        return moment(timestamp).format(pattern)
      } else {
        return null
      }
    },
    addOption (index) {
      this.newCustomComponent.optionsArray.splice(index + 1, 0, {name: ''})
    },
    removeOption (index) {
      this.newCustomComponent.optionsArray.splice(index, 1)
    },
    parseOptions (options) {
      return JSON.parse(options)
    },
    removeComponent (stepIndex, componentIndex) {
      this.signSetting.signMeetingSteps[stepIndex].componentList.splice(componentIndex, 1)
    },
    setComponentGroups (groups) {
      this.componentGroups = groups
    },
    handleClone (original) {
      return JSON.parse(JSON.stringify(original))
    },
    setSignSetting (signSetting) {
      let mobileComponent
      let nameComponent
      let emailComponent
      let positionComponent
      let companyNameComponent

      this.wrappedComponentGroups.forEach(group => {
        group.formComponentList.forEach(component => {
          if (component.signFormComponent.id === 1) {
            mobileComponent = JSON.parse(JSON.stringify(component))
          }

          if (component.signFormComponent.id === 2) {
            nameComponent = JSON.parse(JSON.stringify(component))
          }

          if (component.signFormComponent.id === 4) {
            emailComponent = JSON.parse(JSON.stringify(component))
          }

          if (component.signFormComponent.id === 6) {
            positionComponent = JSON.parse(JSON.stringify(component))
          }

          if (component.signFormComponent.id === 101) {
            companyNameComponent = JSON.parse(JSON.stringify(component))
          }
        })
      })
      mobileComponent.isRequired = true
      nameComponent.isRequired = true
      emailComponent.isRequired = true
      positionComponent.isRequired = true
      companyNameComponent.isRequired = true

      if (!signSetting) {
        signSetting = {
          signNeedApproval: true,
          signMeetingSteps: [
            {title: '企业信息', componentList: [companyNameComponent]},
            {title: '参会人信息', componentList: [nameComponent, mobileComponent, emailComponent, positionComponent]}
          ]
        }
      } else {
        if (!signSetting.signMeetingSteps) {
          signSetting.signMeetingSteps = [
            {title: `企业信息`, componentList: [companyNameComponent]},
            {title: '参会人信息', componentList: [nameComponent, mobileComponent, emailComponent, positionComponent]}
          ]
        }
        if (signSetting.signNeedApproval !== true && signSetting.signNeedApproval !== false) {
          signSetting.signNeedApproval = true
        }
        if (!signSetting.signLimitPersonNumber) {
          signSetting.signLimitPersonNumber = null
        }
      }

      this.signSetting = signSetting
    },
    getSignSetting () {
      let signSetting = {...this.signSetting}

      signSetting.signMeetingSteps.forEach(step => {
        step.meetingId = this.meetingId
        step.componentList.forEach((component, index) => {
          component.meetingId = this.meetingId
          component.stepId = step.id
          component.componentOrder = index
          component.signFormComponentId = component.signFormComponent.id
        })
      })

      return signSetting
    },
    getNewCustomComponent () {
      let component = {}
      component.label = this.newCustomComponent.label
      component.type = this.newCustomComponent.type
      component.valueLength = this.newCustomComponent.valueLength
      if (component.type === 'uploadConfigImg') {
        component.uploadFileAllowTypes = this.newCustomComponent.uploadFileAllowTypes
        component.uploadFileMaxKbSize = this.newCustomComponent.uploadFileMaxMbSize * 1024
        component.uploadMultiple = Boolean(this.newCustomComponent.uploadMultiple)
        component.tips = this.newCustomComponent.tips
        component.errorTips = this.newCustomComponent.errorTips
      }
      let allNotEmptyOptions = []
      this.newCustomComponent.optionsArray.forEach((item, index) => {
        if (item.name !== '') {
          if (component.type === 'checkbox') {
            allNotEmptyOptions.push({name: item.name, value: index})
          } else {
            allNotEmptyOptions.push({name: item.name, value: item.name})
          }
        }
      })
      component.options = JSON.stringify(allNotEmptyOptions)

      return component
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
      this.saved = false
    },
    async removeCustomComponent (id) {
      try {
        this.beforeSave()
        console.log(id)
        await this.$http.delete(`/api/admin/meetings/sign/setting/customComponent/${id}`)
        let customGroup = this.componentGroups.find(item => {
          return item.id === 3
        })
        let matchedIndex = -1
        customGroup.formComponentList.forEach((item, index) => {
          if (item.id === id) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          customGroup.formComponentList.splice(matchedIndex, 1)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async saveCustomComponent () {
      let validPass = false
      this.$refs['customComponentFormValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      console.log(validPass)

      if (!validPass) {
        this.modalLoading = false
        this.$nextTick(() => {
          this.modalLoading = true
        })
        return
      }

      try {
        this.beforeSave()
        let customGroup = this.componentGroups.find(item => {
          return item.id === 3
        })
        if (this.newCustomComponent.id) {
          let signFormComponent = (await this.$http.put(`/api/admin/meetings/sign/setting/customComponent/${this.newCustomComponent.id}`, this.getNewCustomComponent())).body
          let matchedIndex = -1
          customGroup.formComponentList.forEach((item, index) => {
            if (item.id === this.newCustomComponent.id) {
              matchedIndex = index
            }
          })
          if (matchedIndex !== -1) {
            customGroup.formComponentList.splice(matchedIndex, 1, signFormComponent)
          }
        } else {
          let signFormComponent = (await this.$http.post(`/api/admin/meetings/sign/setting/customComponent`, this.getNewCustomComponent())).body
          customGroup.formComponentList.splice(0, 0, signFormComponent)
        }

        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
      this.showCustomComponentDialog = false
    },
    async save () {
      let validPass = false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        return
      }

      try {
        this.beforeSave()
        if (this.id) {
          // 更新设定
          this.signSetting = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/sign/setting/${this.id}`, this.getSignSetting())).body
          this.$router.push({name: 'meeting-list'})
        } else {
          // 创建设定
          this.signSetting = (await this.$http.post(`/api/admin/meetings/${this.meetingId}/sign/setting`, this.getSignSetting())).body
          this.$router.push({name: 'meeting-list'})
          // this.$router.push({name: 'meeting-sign-setting-detail', params: {id: this.signSetting.id}})
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    let componentGroups = []
    let meeting = {}
    try {
      componentGroups = (await Vue.http.get(`/api/admin/meetings/sign/setting/components/groups`)).body
      meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
    } catch (e) {
      next(vm => {
        vm.setComponentGroups([])
        vm.setSignSetting({})
        vm.meeting = {}
        vm.saving = false
        vm.saved = false
      })

      return
    }

    if (to.params.id) {
      try {
        let setting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/sign/setting`)).body
        next(vm => {
          vm.setComponentGroups(componentGroups)
          vm.setSignSetting(setting)
          vm.meeting = meeting
          vm.saving = false
          vm.saved = false
        })
      } catch (e) {
        next(vm => {
          vm.setComponentGroups(componentGroups)
          vm.setSignSetting({})
          vm.meeting = {}
          vm.saving = false
          vm.saved = false
        })
      }
    } else {
      let setting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/sign/setting`)).body
      next(vm => {
        vm.setComponentGroups(componentGroups)
        vm.setSignSetting({})
        vm.meeting = meeting
        vm.saving = false
        vm.saved = false
        if (setting && setting.id) {
          vm.$router.replace({
            name: 'meeting-sign-setting-detail',
            params: {
              meetingId: to.params.meetingId,
              id: setting.id
            }})
        }
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    let componentGroups = []
    try {
      componentGroups = (await Vue.http.get(`/api/admin/meetings/sign/setting/components/groups`)).body
    } catch (e) {
      this.setComponentGroups([])
      this.setSignSetting({})
      this.meeting = {}
      this.saving = false
      this.saved = false
      next()
      return
    }

    if (to.params.id) {
      try {
        let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
        let setting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/sign/setting`)).body
        this.setComponentGroups(componentGroups)
        this.setSignSetting(setting)
        this.meeting = meeting
        this.saving = false
        this.saved = false
        next()
      } catch (e) {
        this.setComponentGroups(componentGroups)
        this.setSignSetting({})
        this.meeting = {}
        this.saving = false
        this.saved = false
        next()
      }
    } else {
      let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
      let setting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/sign/setting`)).body

      this.setComponentGroups(componentGroups)
      this.setSignSetting({})
      this.meeting = meeting
      this.saving = false
      this.saved = false
      if (setting && setting.id) {
        this.$router.replace({
          name: 'meeting-sign-setting-detail',
          params: {
            meetingId: to.params.meetingId,
            id: setting.id
          }})
      }
      next()
    }
  }
}
</script>
<style>
  #settingCard > .ivu-card-body {
    background-color: #d2d5d9;
  }
  .meeting-components > .ivu-card-body {
    background-color: #f7f7f7;
  }
</style>
<style scoped="scoped" scss>
  /*.meeting-form {*/
    /*width: 900px;*/
    /*margin: 0 auto;*/
    /*padding-right: 180px;*/
  /*}*/
  .ivu-form .ivu-form-item-label {
    font-size: 13px !important;
  }
  .iview-admin-draggable-list{
    height: 100%;
    min-height: 60px;
  }
  .iview-admin-draggable-list.meeting-component {
    padding-bottom: 60px;
  }
  .iview-admin-draggable-list li.todolist-item{
    padding: 9px;
    border: 1px solid #e7ebee;
    border-radius: 3px;
    margin-bottom: 5px;
    position: relative;
    transition: all .2s;
  }

  .iview-admin-draggable-list li.todolist-item:not(.mustComponent) {
    cursor: pointer;
  }

  .system-components .iview-admin-draggable-list li.todolist-item {
    display: inline-block;
  }
  .iview-admin-draggable-list li.todolist-item:hover{
    color: #87b4ee;
    border-color: #87b4ee;
    transition: all .2s;
  }
  .iview-admin-draggable-delete{
    height: 100%;
    position: absolute;
    right: -8px;
    top: 0px;
    display: none;
  }
  .iview-admin-draggable-list li.todolist-item:hover .iview-admin-draggable-delete{
    display: block;
  }
  .placeholder-style{
    display: block !important;
    color: transparent;
    border-style: dashed !important;
  }
  .delte-item-animation{
    opacity: 0;
    transition: all .2s;
  }
  .iview-admin-draggable-list{
    overflow: auto;
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/MeetingSignSetting.vue